export const createAction = <T extends string | number, P>(
    type: T,
    payload: P = {} as P
) => ({
    type,
    payload
});
